import { COMPARISON_ROWS, USE_OF_FUNDS } from "./investData";

const Dot = ({ active }) => (
  <span className={`mx-auto block h-2 w-2 ${active ? "bg-[#79c997]" : "border border-white/20"}`} aria-label={active ? "Included" : "Not included"} />
);

export const InvestorOpportunity = () => (
  <>
    <section className="border-b border-[color:var(--line)]" data-testid="invest-round">
      <div className="mx-auto max-w-site px-6 py-24 md:px-10 md:py-32">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="label !text-[10px] text-[color:var(--ink-3)]">03 / The round</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-4xl leading-[1.02] sm:text-5xl" data-testid="invest-round-title">
              Built with conviction.<br /><span className="editorial font-normal">Opening with discipline.</span>
            </h2>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 border-l border-t border-[color:var(--line)] lg:grid-cols-4">
          {[
            ["$1M", "Target raise", "SAFE financing"],
            ["$10M", "Valuation cap", "Simple, aligned terms"],
            ["$100K", "Founder capital", "Already invested"],
            ["Gunderson", "Legal counsel", "Gunderson Dettmer"],
          ].map(([value, label, note], index) => (
            <div key={label} className="min-h-[210px] border-b border-r border-[color:var(--line)] p-6 md:p-8" data-testid={`invest-term-${index}`}>
              <div className={`${value === "Gunderson" ? "text-2xl md:text-3xl" : "text-4xl md:text-5xl"} font-display leading-none`}>{value}</div>
              <div className="mt-9 label !text-[9px]">{label}</div>
              <div className="mt-2 text-sm text-[color:var(--ink-3)]">{note}</div>
            </div>
          ))}
        </div>

        <div className="mt-20 grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-4">
            <h3 className="font-display text-3xl">Use of funds</h3>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[color:var(--ink-3)]">The round is designed to move Vitura from a founder-funded product into a durable consumer platform.</p>
          </div>
          <div className="border-t border-[color:var(--line)] md:col-span-8">
            {USE_OF_FUNDS.map(([index, title, copy]) => (
              <div key={index} className="grid grid-cols-[32px_110px_1fr] gap-3 border-b border-[color:var(--line)] py-5 sm:grid-cols-[48px_150px_1fr]" data-testid={`invest-use-${index}`}>
                <span className="font-mono text-[10px] text-[color:var(--ink-3)]">{index}</span>
                <span className="text-sm font-medium">{title}</span>
                <span className="text-sm leading-relaxed text-[color:var(--ink-2)]">{copy}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    <section className="bg-[#0a0b0a] text-[#faf9f5]" data-testid="invest-category">
      <div className="mx-auto max-w-site px-6 py-24 md:px-10 md:py-32">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="label !text-[10px] !text-white/50">04 / Category of one</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="max-w-3xl font-display text-4xl leading-[1.02] sm:text-5xl" data-testid="invest-category-title">
              All-day performance,<br /><span className="editorial font-normal">without sacrifices.</span>
            </h2>
            <p className="mt-6 max-w-2xl text-[15px] leading-relaxed text-white/65">
              Energy drinks pull one lever hard. Focus shots stop at the desk. Vitura is built for people training hard and thinking hard—fifteen ingredients covering the whole day, not one hour of it.
            </p>
          </div>
        </div>

        <div className="mt-14 border-t border-white/15" data-testid="invest-comparison-table">
          <div className="grid grid-cols-[minmax(0,1.8fr)_repeat(4,minmax(0,.55fr))] border-b border-white/15 py-4 label !text-[7px] !text-white/50 sm:!text-[9px]">
            <span>Capability</span><span className="text-center !text-[#79c997]">Vitura</span><span className="text-center">Focus</span><span className="text-center">Energy</span><span className="text-center">Coffee</span>
          </div>
          {COMPARISON_ROWS.map((row, rowIndex) => (
            <div key={row.label} className="grid min-h-16 grid-cols-[minmax(0,1.8fr)_repeat(4,minmax(0,.55fr))] items-center border-b border-white/15" data-testid={`invest-comparison-row-${rowIndex}`}>
              <span className="pr-2 text-[12px] leading-tight text-white/78 sm:text-sm">{row.label}</span>
              {row.values.map((value, index) => <Dot key={`${row.label}-${index}`} active={value} />)}
            </div>
          ))}
        </div>

        <p className="mt-12 max-w-xl font-display text-2xl leading-snug" data-testid="invest-category-close">
          Same daily price as a Celsius. Zero sugar. Zero sucralose. Zero crash.
        </p>
      </div>
    </section>
  </>
);